import React from 'react'
import { createStackNavigator } from '@react-navigation/stack'
import { BottomTabs } from 'navigation/bottom-tabs'
import { AuthScreen } from 'ui/auth/auth-screen'
import { observer } from 'mobx-react'
import { authStore } from 'store/auth'
import { InitScreen } from 'ui/init/init-screen'

const Stack = createStackNavigator()

export const RootStack = observer(() => {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      {!authStore.isInitialized ? (
        <Stack.Screen name='InitScreen' component={InitScreen} />
      ) : !authStore.isLoggedIn ? (
        <Stack.Screen name='AuthScreen' component={AuthScreen} />
      ) : (
        <Stack.Screen name='BottomTabs' component={BottomTabs} />
      )}
    </Stack.Navigator>
  )
})
